import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  GetFplOptions,
  GetFplRequestDto,
  GetFplResponseDto,
} from './get-fpl.types';

export function getFpl(
  baseUrl: string,
  body: GetFplRequestDto,
  options?: GetFplOptions,
): Promise<IHttpResponse<GetFplResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};
  const url = `${baseUrl}/api/quotes-api/v1/federal-poverty-level`;

  const request: IHttpRequest<GetFplRequestDto> = {
    url,
    method: 'POST',
    headers,
    body,
    schemas: {
      request: GetFplRequestDto,
      response: GetFplResponseDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
